import { render, staticRenderFns } from "./InscriptionForm.vue?vue&type=template&id=4500a86c&scoped=true&"
import script from "./InscriptionForm.vue?vue&type=script&lang=js&"
export * from "./InscriptionForm.vue?vue&type=script&lang=js&"
import style0 from "./InscriptionForm.vue?vue&type=style&index=0&id=4500a86c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4500a86c",
  null
  
)

export default component.exports